import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
  data: null,
  pages: null,
  count: null,
  loading: false,
  error: null,
};

export const GetUserActivityRemarkList = createAsyncThunk(
  "GetUserActivityRemarkList",
  async (body) => {
    try {
      const response = await instance.get(
        `/remark/user/user-activity-tracker?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate=${body.endDate}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);


export const UserActivityRemarkSlice = createSlice({
  name: "UserActivityRemarkSlice",
  initialState,

  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetUserActivityRemarkList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(GetUserActivityRemarkList.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.pages = action?.payload?.pages;
      state.count = action?.payload?.count;

    });
    builder.addCase(GetUserActivityRemarkList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default UserActivityRemarkSlice.reducer;
